import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.inline-edit-credit-card-item.presenters.InlineEditCreditCardItemPresenter`

export default defineMessages({
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  genericErrorMessage: {
    id: `${scope}.genericErrorMessage`,
    defaultMessage: 'Unable to update the item cost.',
  },
})
